<template>
    <div v-if="filter_tags" class="tags">
        <tag v-for="tag in filter_tags"
             :key="tag.id"
             :name="tag.name"
             :color="tag.color"
             :show_remove="true"
             @remove="remove(tag)"/>
    </div>
</template>

<script>
import { mapState } from 'vuex';
import without from 'lodash/without';
import { copy } from '../../utils/helpers';
import get_query_list from '../../utils/router';
import Tag from '../tag/Tag.vue';

export default {
    name: 'NoteListTagsList',
    components: { Tag },
    props: ['space'],
    computed: {
        ...mapState('tags', ['list', 'filter_tags']),
        tag_ids() {
            return get_query_list(this.$route.query.tags).map(Number);
        },
    },
    mounted() {
        if (this.tag_ids.length) {
            this.$store.dispatch('tags/list', {
                space_id: this.space.id,
                ids: this.tag_ids,
            }).then((data) => {
                this.$store.commit('tags/add_filter_tags', data.results);
            });
        }
    },
    destroyed() {
        this.$store.commit('tags/clean_filter_tags');
    },
    methods: {
        remove(tag) {
            this.$store.commit('tags/remove_filter_tag', tag.id);
            const query = copy(this.$route.query);
            query.tags = without(this.tag_ids, tag.id);
            this.$router.push({ name: 'content', params: this.$route.params, query });
        },
    },
};
</script>

<style scoped>
    .tag {
        background-color: #727272;
        color: whitesmoke;
    }

    .tag > .delete {
        background-color: transparent;
    }
</style>
